export const BRIEF_STATUS = {
  created: 'created',
  submitted: 'submitted',
  done: 'done',
  doneWithErrors: 'done_with_errors',
} as const;
export type BriefStatus = (typeof BRIEF_STATUS)[keyof typeof BRIEF_STATUS];
